module.exports = __webpack_public_path__ + "img/lg_ring_y_l_1_null.0f2f66b6.png";